import { defaultWebsiteId } from '@va/constants';
import { activeWebsiteSlice } from '@va/dashboard/slices';
import { WebsiteResponse } from '@va/types/website';
import md5 from 'blueimp-md5';
import { createSelector } from 'reselect';
import { getInstanceId } from './instance-id';

const {
  selectWebsiteRole,
  isWebsiteContributor,
  hasUserRole,
  isWebsiteOwner,
  selectData,
  selectIsLoading,
  selectCoreInfo,
  selectExtraInfo,
  isInitialized,
  selectVisitLimitReachedAt,
} = activeWebsiteSlice.getSelectors((state: any) => state.get('core').get('activeWebsite'));

export const websiteRoleSelectors = {
  selectWebsiteRole,
  isWebsiteContributor,
  hasUserRole,
  isWebsiteOwner,
};

export const activeWebsiteSelectors = {
  selectData,
  selectIsLoading,
  isInitialized,
  selectCoreInfo: createSelector([selectCoreInfo, getInstanceId], (website, websiteId) => {
    return Object.assign({}, website, {
      id: website.id || websiteId,
      isPremium: !!website?.isPayable,
      // @ts-ignore
      installDate: parseInt(website.installDate),
      hash: md5(website.id || websiteId),
      exists: websiteId !== defaultWebsiteId,
    }) as WebsiteResponse & {
      isPremium: boolean;
      installDate: number;
      hash: string;
      exists: boolean;
      inProgress: boolean;
      termsAndDpaAccepted?: boolean;
    };
  }),
  selectExtraInfo,
  selectVisitLimitReachedAt,
};

export const selectHasMetadata = createSelector(activeWebsiteSelectors.selectCoreInfo, (website) => {
  return website.frontendFlags?.['hasMetadata'] ?? false;
});
